import React from 'react';
import { TextField, MenuItem, Grid } from '@mui/material';

const Specialization = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Industry Specialization"
          name="industrySpecialization"
          value={formData.industrySpecialization || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Banking">Banking</MenuItem>
          <MenuItem value="NBFC">NBFC</MenuItem>
          <MenuItem value="FinTech">FinTech</MenuItem>
          <MenuItem value="Audit">Audit</MenuItem>
          <MenuItem value="Insurance">Insurance</MenuItem>
          <MenuItem value="Mutual Funds">Mutual Funds</MenuItem>
          <MenuItem value="Private Equity">Private Equity</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Functional Specialization"
          name="functionalSpecialization"
          value={formData.functionalSpecialization || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Investment Banking">Investment Banking</MenuItem>
          <MenuItem value="Treasury">Treasury</MenuItem>
          <MenuItem value="Risk Management">Risk Management</MenuItem>
          <MenuItem value="Taxation">Taxation</MenuItem>
          <MenuItem value="Controllership">Controllership</MenuItem>
          <MenuItem value="FP&A">FP&A</MenuItem>
          <MenuItem value="Audit">Audit</MenuItem>
          <MenuItem value="IT">IT</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Experience with Financial Tools/Software"
          name="financialToolsSoftware"
          value={formData.financialToolsSoftware || []}
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="SAP">SAP</MenuItem>
          <MenuItem value="QuickBooks">QuickBooks</MenuItem>
          <MenuItem value="Tally">Tally</MenuItem>
          <MenuItem value="Bloomberg Terminal">Bloomberg Terminal</MenuItem>
          <MenuItem value="Excel VBA">Excel VBA</MenuItem>
          <MenuItem value="Oracle ERP">Oracle ERP</MenuItem>
          <MenuItem value="Power BI">Power BI</MenuItem>
          <MenuItem value="Tableau">Tableau</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default Specialization;